import React from 'react'
import { Typography } from '@material-ui/core'
import FilterBar from './FilterBar'
import Content from './Content'
import './logbook-forms.scss'

function LogbookForm(props) {
  return (
    <div className="module logbook-forms-module">
      <div className="module-head">
        <Typography className="module-title" variant="h5">
          {props.currentApp.name}
        </Typography>
      </div>
      <FilterBar />
      <Content />
    </div>
  )
}

export default LogbookForm
